import { bootstrapApplication } from '@angular/platform-browser';
import { initializeSentry } from '@thiememeulenhoff/ng-sdk';
import { setGlobalConfig } from '@thiememeulenhoff/js-sdk';
import { initializeTranslations } from '@thiememeulenhoff/translations';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import '@thiememeulenhoff/albert';

initializeSentry(
  'https://a1e1d14da2a6541dff349c6e701b05b7@o1127103.ingest.us.sentry.io/4508788308639744',
  {
    enabled: environment.production,
    environment: environment.environment,
    release:
      typeof RELEASE_VERSION === 'undefined' ? undefined : RELEASE_VERSION,
    replaysSessionSampleRate: 0,
  },
);

initializeTranslations();

setGlobalConfig({
  environment: environment.auth.environment,
});

bootstrapApplication(AppComponent, appConfig).catch(console.error);
